interface Props {
	width?: number | string;
	height?: number | string;
	viewBox?: string;
}

export const PhoneIcon: React.FC<Props> = ({
	width = '6',
	height = '10',
	viewBox = '0 0 8 12',
}) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox={viewBox}>
		<path
			id="iconmonstr-phone-1_1_"
			data-name="iconmonstr-phone-1 (1)"
			d="M12,11.311l-1.761-3.4s-.987.485-1.032.506c-1.12.543-3.4-3.91-2.3-4.5l1.042-.513L6.2,0,5.145.52c-3.6,1.878,2.117,12.991,5.8,11.308C11.006,11.8,12,11.313,12,11.311Z"
			transform="translate(-4)"
			fill="#0064C7"
		/>
	</svg>
);
